import { TrashIcon } from "@phosphor-icons/react/Trash";

interface DashboardRowDeleteButtonProps {
  onClick: () => Promise<void>;
}

export function ShipmentRowDeleteAction(props: DashboardRowDeleteButtonProps) {
  return (
    <button type="button" className="cursor-pointer" onClick={props.onClick}>
      <TrashIcon
        className="ml-8 h-5 w-5 text-content-faint hover:text-foreground"
        weight="fill"
      />
    </button>
  );
}
